<script>
  export let name;
  export let status = '';
  export let color = 0;
  export let timestamp = null;
  // export let timestamp;

  $: ts = timestamp ? new Date(timestamp).toLocaleString() : '';

  import Light from './Light.svelte';
</script>

<style>
  .inline {
    display: inline-block;
    vertical-align: middle;
  }
  .status {
    height: 12px;
    margin-top: -2px;
    font-size: x-small;
    color: #333;
    margin-left: 20px;
    /* background-color: yellow */
  }

  .timestamp {
    float: right;
  }
</style>

<div class="main">
  <Light size={15} color={color} />
  <div class="inline">{name}</div> 
  <div class="status is-lowercase">
    <span class="timestamp">{ts}&nbsp;</span>
    <span>{status}</span>
  </div>
</div>
